import styled from "styled-components";

export const Container = styled.div`
  /* Fills the column up to 720px even when nested in another Container (the settings sub-routes),
     where the auto margins alone would shrink it to its content */
  width: 100%;
  max-width: min(720px, 100%);
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
`;
